import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';

/**
 * Placeholder for cross-tenant user administration (/admin/users). Distinct
 * from the tenant-scoped user-management feature, which manages users within a
 * single organization. Stub for now.
 */
@Component({
  selector: 'app-admin-users',
  standalone: true,
  imports: [TranslocoDirective],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <section *transloco="let t" class="flex flex-col gap-2">
      <h1 class="text-heading font-semibold text-ink-1">{{ t('admin.users.title') }}</h1>
      <p class="text-body text-ink-2">{{ t('admin.users.placeholder') }}</p>
    </section>
  `,
})
export class AdminUsersComponent {}
